import axios from "axios";
import AuthService from "./auth.service";

const API_URL = process.env.REACT_APP_API_URL;

class CartService {
  async add_item(itemData) {
      const USR_TOKEN = localStorage.getItem("userToken")
      if(USR_TOKEN){
         
        return axios
          .post(API_URL + "api/method/ecom.api.update_item", itemData, {
            headers : {'Authorization' : USR_TOKEN, 'content-type': 'application/json'}}
            )
          .then(response => {
             // console.log(response.data)
              this.update_cart()
              console.log(response.headers);
          })
          .catch(error=>{ 
           /*  if (error.response) {
               
                console.log(error.response);
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);
            } else if (error.request) {
               
                console.log(error.request);
                console.log(error.request.onerror);
                console.log(error.request);
                console.log(error.request.data);
                console.log(error.request.status);
                console.log(error.request.headers);
            } else {
                
                console.log('Error', error.message);
            } */
            alert(error);
                //console.log(error.response.data.errors);
                //console.log(error.toJSON());
        })
      }
  }
  async place_order(){
    const USR_TOKEN = localStorage.getItem("userToken")
    if(USR_TOKEN){
        let qoute = { qoute: 'Deo'}
        return axios.post(process.env.REACT_APP_API_URL + encodeURI('api/method/ecom.api.order_place'), qoute, {
        headers : {'Authorization' : USR_TOKEN, 'content-type': 'application/json'}
        })
        .then(response=>{
            localStorage.removeItem('cart');
            localStorage.removeItem('servercart');
            console.log('Order Placed')
            let url = response.data.message.payment.payment_link
            if (url){
              window.location.href=url
            }
            console.log(response.data)
            return response.data
        })

    }
}
 async place_agent_order(orderID, itemDate){
    const USR_TOKEN = localStorage.getItem("userToken")
    if(USR_TOKEN){
        let qoute = { orderid: orderID, data: itemDate }
        return axios.post(process.env.REACT_APP_API_URL + encodeURI('api/method/ecom.api.place_agentpayment'), qoute, {
        headers : {'Authorization' : USR_TOKEN, 'content-type': 'application/json'}
        })
        .then(response=>{
            console.log('Order Placed')
            return response.data
        })

    }
}
async payment_initiate(){
    const USR_TOKEN = localStorage.getItem("userToken")
    if(USR_TOKEN){
        let qoute = { qoute: 'Deo'}
        return axios.post(process.env.REACT_APP_API_URL + encodeURI('api/method/ecom.api.payment_process'), qoute, {
        headers : {'Authorization' : USR_TOKEN, 'content-type': 'application/json'}
        })
        .then(response=>{
           // console.log('Order Placed')
            return response.data
        })

    }
} 
async agent_payment_initiate(){
    const USR_TOKEN = localStorage.getItem("userToken")
    if(USR_TOKEN){
        let qoute = { qoute: 'Deo'}
        return axios.post(process.env.REACT_APP_API_URL + encodeURI('api/method/ecom.api.agentpayment_process'), qoute, {
        headers : {'Authorization' : USR_TOKEN, 'content-type': 'application/json'}
        })
        .then(response=>{
           // console.log('Order Placed')
            return response.data
        })

    }
} 
    async processPayment(){
       

    }

    async transfer_cart(){    //transfer local cart items to server
        //const delay = ms => new Promise(res => setTimeout(res, ms));

        const USR_TOKEN = localStorage.getItem("userToken")
        if(USR_TOKEN){
            
            try{
                let cart = AuthService.getCartitems()
                //alert(cart)
                if(cart.length > 0){
                        for (let itm in cart) {
                            const itemData= { 
                                item_code:cart[itm]['item_code'],
                                qty:cart[itm]['qty'],
                                pin:localStorage.getItem("pin")
                            }
                            this.add_item(itemData)
                            //await delay(2000);
                            console.log("Item Addes: " + cart[itm]['item_code'] )
                            console.log("----------------------" )
                        }
                        localStorage.removeItem('cart');
                }       
            }
            catch(er){ //alert ("Cart Error.#2001");  
            }

        }
    }


    async update_cart(){
        
        const USR_TOKEN = localStorage.getItem("userToken")
        if(USR_TOKEN){
           
            axios.get(process.env.REACT_APP_API_URL + encodeURI('api/method/ecom.api.get_cart_count'),{
                headers : {'Authorization' : USR_TOKEN, 
                'content-type': 'application/json'}
            })
            .then(response=>{
                
                if(response.data['message'][0]['count'] === 0){
                   
                    document.getElementById("pro-count2").innerText = ''
                    document.querySelector(".counter").style.setProperty("display","none ");  
                }
                else{

                    document.getElementById("pro-count").innerText = response.data['message'][0]['count']
                    document.getElementById("pro-count2").innerText = response.data['message'][0]['count']
                    document.querySelector(".counter").style.setProperty("display","block ");  
                }
                if(window.location.pathname === '/cart'){
                    document.querySelector(".mob-sticky-cart").style.setProperty("display","none !important"); 
                }else{
                    if(response.data['message'][0]['count'] > 0){
                        document.querySelector(".mob-sticky-cart").style.setProperty("display","block");
                    }
                    else{ 
                        document.querySelector(".mob-sticky-cart").style.setProperty("display","none !important");
                    }

                }
                //document.getElementById("cart-amount").innerText = response.data['message'][0]['total']
                console.log("count -" +response.data['message'][0]['count'])
                return 'Cart Count'
            })
            .catch(err=>{  return 'Error Count axios' })

        }
        else{

            return 'Error Count'
        }
    }
  async update_cart_local(){
    try{
        let cart = AuthService.getCartitems()
        let count = cart.length
        //let total = parseFloat(0.00);
        if(cart.length > 0){
        
               /*  for (let itm in cart) {
                    total += parseFloat(cart[itm]['rate']);
                }  */
        }
        document.getElementById("pro-count").innerText = count
        document.getElementById("pro-count2").innerText = count
        if(count === 0){
            document.getElementById("pro-count2").innerText = ''
        }

    // document.getElementById("cart-amount").innerText = total  

    }
    catch(er){}

 }

  async updateProfile(userData){

      
      const USR_TOKEN = localStorage.getItem("userToken")
      if(USR_TOKEN){
          return axios.post(API_URL + "/api/method/ecom.api.updateProfile", userData, {
                headers : {'Authorization' : USR_TOKEN,  'content-type': 'application/json'}}
          )
          .then(response=>{
                console.log(response)
          })
          .catch(err =>{ console.log(err)})
        }
  }
  async removeItem(item_code){

    const USR_TOKEN = localStorage.getItem("userToken")
    if(USR_TOKEN){
        //alert("ok")
        let itemData={
            item_code:item_code, 
            qty: 0,
            pin:localStorage.getItem("pin")
          }
          let cart = AuthService.getserverCartitems()
          //alert(cart)
          for(var i = 0; i < cart.length; i++){ 
            if (cart[i]['item_code'] === item_code) { 
                cart.splice(i, 1);
            }
        }
        localStorage.setItem("servercart", JSON.stringify(cart));
        return this.add_item(itemData)
        
    }else{

        let cart = AuthService.getCartitems()

        for(i = 0; i < cart.length; i++){ 
            if (cart[i]['item_code'] === item_code) { 
                cart.splice(i, 1);
            }
        }
        localStorage.setItem("cart", JSON.stringify(cart));
    }
}
    

      
async setAddress(addressName,pincode ){
    const USR_TOKEN = localStorage.getItem("userToken")
    if(USR_TOKEN){
        let adData = {
            'address_name':addressName
        }
        return axios.post(process.env.REACT_APP_API_URL + encodeURI('api/method/ecom.api.set_cart_addresses'), adData,{
            headers : {'Authorization' : USR_TOKEN, 'content-type': 'application/json'}
        })
        .then(res=>{  console.log(res.data) 
            localStorage.setItem('pin', res.data['message'][0]['pin_code']);
            localStorage.setItem('location', res.data['message'][0]['location']);
            localStorage.setItem('district', res.data['message'][0]['district']);
            localStorage.setItem("tempPin", pincode)

            //alert(pin)
           window.location.href='/cart'       
         })
    }

}

  async updateAddress(addressData){
      // Args address_line1, address_line2, city, country
      const USR_TOKEN = localStorage.getItem("userToken")
      if(USR_TOKEN){

            axios.post(process.env.REACT_APP_API_URL + encodeURI('api/method/ecom.api.add_new_address'), addressData,{
                headers : {'Authorization' : USR_TOKEN, 
                'content-type': 'application/json'}
            })
            .then(response=>{
                console.log(response.data)
                let adData = {
                    'address_name':response.data['message'].name
                }
                return axios.post(process.env.REACT_APP_API_URL + encodeURI('api/method/ecom.api.set_cart_addresses'), adData,{
                    headers : {'Authorization' : USR_TOKEN, 
                    'content-type': 'application/json'}
                })
                .then(res=>{  console.log(res.data) })
            })
      }

  }

  async getCart(){
        const USR_TOKEN = localStorage.getItem("userToken")
        if(USR_TOKEN){
            return axios.get(process.env.REACT_APP_API_URL + 'api/method/ecom.api.get_cart_quote',{
                headers : {'Authorization' : USR_TOKEN, 
                'content-type': 'application/json'}
            })
            .then(response=>{
                console.log(response.data['message']['doc']['items'])
                return response.data['message']
            })
            .catch(err=>{return (err)})
        }


  }
  async addQty(item,qty){
    const USR_TOKEN = localStorage.getItem("userToken")
    if(USR_TOKEN){
        const itemData= { 
            item_code:item,
            qty:qty + 1,
            pin:localStorage.getItem("pin")
        }

        let cart = AuthService.getserverCartitems()
        if (cart){
            
            for( var i = 0; i < cart.length; i++){ 
                if (cart[i]['item_code'] === item) { 
                    cart[i]['qty']=qty + 1
                   // alert("cart")
                }
            }
           // cart.push(itemData)
            localStorage.setItem("servercart", JSON.stringify(cart));
           // console.log('server cart')
           // console.log(cart)
            //this.setState({disabled:"disabled"})
            
        }
        //console.log(itemData)
        return this.add_item(itemData)
        
    }
    else{
        let cart = AuthService.getCartitems()
        //alert(cart.length)
        if(cart.length > 0){
            for(  i = 0; i < cart.length; i++){ 
                if (cart[i]['item_code'] === item) { 
                    cart[i]['qty']=qty + 1
                   // alert("cart")
                }
            }
            localStorage.setItem("cart", JSON.stringify(cart));
            return cart
        }
    }
}
async subQty(item,qty){
    const USR_TOKEN = localStorage.getItem("userToken")
    if(USR_TOKEN){
        const itemData= { 
            item_code:item,
            qty:qty - 1,
            pin:localStorage.getItem("pin")
        }
        let cart = AuthService.getserverCartitems()
        if (cart){
         
            for( var i = 0; i < cart.length; i++){ 
                if (cart[i]['item_code'] === item ) { 
                    cart[i]['qty']=qty - 1
                    if(qty <= 1){
                        cart.splice(i, 1);
                    }
                    //arr.splice(i, 1); 
                }
        }
           // cart.push(itemData)
            localStorage.setItem("servercart", JSON.stringify(cart));
            //console.log('server cart')
           // console.log(cart)
            //this.setState({disabled:"disabled"})
            
        }

        return this.add_item(itemData)
    }
    else{
        let cart = AuthService.getCartitems()
        
        if(cart.length > 0){
            for( i = 0; i < cart.length; i++){ 
                    if (cart[i]['item_code'] === item ) { 
                        cart[i]['qty']=qty - 1
                        if(qty <= 1){
                            cart.splice(i, 1);
                        }
                        //arr.splice(i, 1); 
                    }
            }
            localStorage.setItem("cart", JSON.stringify(cart))
            this.update_cart_local()
            this.update_cart()
            return cart
        }
    }  
}
async addMoney(amt) {

    const USR_TOKEN = localStorage.getItem("userToken")
    if(USR_TOKEN){
      let amount ={
        amt:amt
      }
      //const user =  this.getCurrentUser();
      return axios.post(process.env.REACT_APP_API_URL+'api/method/ecom.api.add_money', amount,{
            headers : {'Authorization' : USR_TOKEN, 'content-type': 'application/json'}
      }).then( 
          res =>{ return res }
      )
      .catch(
          err =>{ return err }
      )
    }
    else{
        alert("Not Logged in")
        this.logout()
    }
}
    async addToCart(itemData){
        //alert(itemData.item_code)
        const USR_TOKEN = localStorage.getItem("userToken")
        //localStorage.clear("userToken");
        //console.log(USR_TOKEN)
        if(USR_TOKEN){
            //alert("user")
            let serverData={
                item_code:itemData.item_code, 
                description:itemData.description, 
                qty: itemData.qty, 
                rate:itemData.rate,
            }
            this.add_item(serverData)
            this.update_cart()
            
            let cart = AuthService.getserverCartitems()
            if (cart){
             
               
                cart.push(itemData)
                localStorage.setItem("servercart", JSON.stringify(cart));
                console.log('server cart')
                console.log(cart)
                //this.setState({disabled:"disabled"})
                
            }
            else{
                let ncart = []

                ncart.push(itemData)
                localStorage.setItem("servercart", JSON.stringify(ncart));
                console.log('server cart')
                console.log(ncart)
                //his.setState({disabled:"disabled"})
               

            }
            
        }
        else{
            
            let cart = AuthService.getCartitems()
            if (cart){
                cart.push(itemData)
                localStorage.setItem("cart", JSON.stringify(cart));
                //this.setState({disabled:"disabled"})
            }
            else{
                let ncart = []             
                ncart.push(itemData)
                localStorage.setItem("cart", JSON.stringify(ncart));
                //his.setState({disabled:"disabled"})
            }
            await this.update_cart_local()
           
        }
    }

 
}

export default new CartService();
